module.exports = __webpack_public_path__ + "img/entrees.957fcf5e.png";